<script lang="ts">
	import { formatPrice } from '$lib';
	import { m } from '$lib/paraglide/messages';
	import { getContext } from 'svelte';
	import { slide } from 'svelte/transition';

	import RangeSlider from '../RangeSlider.svelte';
	import FilterDrawer from './FilterDrawer.svelte';
	import { type FilterProvider, type RangeFilter } from './store.svelte';

	const { filter }: { filter: RangeFilter } = $props();

	const filterProvider = getContext<FilterProvider>('filter');

	let min = $derived(Math.floor(filter.min));
	let max = $derived(Math.ceil(filter.max));
	let minValue = $derived(
		Math.floor(Number(filterProvider.checkedFilters[filter.name]?.[0] ?? filter.min)),
	);
	let maxValue = $derived(
		Math.ceil(Number(filterProvider.checkedFilters[filter.name]?.[1] ?? filter.max)),
	);

	const onChange = (newMinValue: number, newMaxValue: number) => {
		if (newMinValue === min && newMaxValue === max) {
			filterProvider.setValues(filter.name, []);
			return;
		}
		filterProvider.setValues(filter.name, [newMinValue.toString(), newMaxValue.toString()]);
	};

	let isOpen = $state(false);
</script>

{#if filter.max > filter.min}
	{#snippet icon()}
		<span class={['icon-[mdi--chevron-down] transition', { 'rotate-180': isOpen }]}></span>
	{/snippet}

	{#snippet selected()}
		{m.range({
			min: formatPrice(minValue),
			max: formatPrice(maxValue),
		})}
	{/snippet}

	<FilterDrawer
		name={m['attributes.price']()}
		{icon}
		onclick={() => (isOpen = !isOpen)}
		selected={!isOpen && (minValue !== min || maxValue !== max) ? selected : undefined}
	>
		{#if isOpen}
			<div transition:slide class="py-2">
				<RangeSlider {min} {max} {minValue} {maxValue} onchange={onChange} />
			</div>
		{/if}
	</FilterDrawer>
{/if}
